<template>
	<modal class="modal-logout" @close="close" v-if="show">
		<div slot="header">
			<h3>{{ $t('confirmation') }}</h3>
		</div>
		<div slot="body">{{ $t('areYouSureWantToLogout') }}?</div>
		<div slot="footer">
			<div class="modal-actions clearfix">
				<button type="button" class="btn btn-lg raised btn-danger" @click="close()">
					{{ $t('no') }}
				</button>
				<button type="button" class="btn btn-lg raised btn-success" @click="confirmLogout()">
					{{ $t('confirm') }}
				</button>
			</div>
		</div>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import userApi from '../api/user';
import Modal from './Modal.vue';

export default {
	name: 'ModalLogout',
	components: {
		Modal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	methods: {
		...mapActions([
			'logout',
		]),
		close() {
			this.$emit('close');
		},
		requestLogout() {
			const errorTitle = this.$t('error');
			userApi.logout().then(() => {
				this.close();
			}).catch((error) => {
				this.$store.dispatch('loginFailed');
				const message = error.response.data.message;
				this.$notify({
					group: 'foo-velocity',
					title: errorTitle,
					text: message,
					type: 'error',
				});
			});
		},
		leaveChannel() {
			if (this.user) {
				const channel = `mymeet-notifications-user-${this.user.id}`;
				this.$socket.emit('unsubscribe', channel);
			}
		},
		confirmLogout() {
			this.leaveChannel();
			this.requestLogout();
			this.logout();
		},
	},
	watch: {
	},
};
</script>
